import GetDigitalAssetsRequestModelBase from '../_generated/modelBases/get-digital-assets-request-model-base';

export default class GetDigitalAssetsRequestModel extends GetDigitalAssetsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
